// import image from './public/user.png';
// import userlogo from '.public/user.png';
import SettingsIcon from "@mui/icons-material/Settings";
import * as React from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HomeHeader.css";
import Settings from "./Modal/Settings";

const HomeHeader = () => {
  const [showdropdown, setshowdropdown] = useState(false);
  const [add, setAdd] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const handleMenu = () => {
    setshowdropdown((state) => !state);
  };

  const handleClose = () => {
    localStorage.setItem("LogRoute", location.pathname);
    localStorage.setItem("authenticated", false);
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_Token");
    localStorage.removeItem("username");
    localStorage.removeItem("userid");
    localStorage.removeItem("groupid");
    localStorage.removeItem("version");

    navigate("/login");
  };

  const handleclick = () => {
    setAdd(true);
  };

  const handleModalClose = () => {
    setAdd(false);
  };

  return (
    <>
      <div
        className="d-flex justify-content-between w-100 mb-5 header-background px-5"
        style={{ position: "fixed", zIndex: 100 }}
      >
        <div>
          <div className="d-flex justify-content-between align-items-center p-2">
            <div
              className="fw-bold text-color mx-5 "
              style={{ fontFamily: "Montserrat" }}
            >
              ROUTER
            </div>
            <div className="mx-2">
              <div className="d-flex justify-content-around"></div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center p-2">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center">
              <div style={{ marginRight: "1rem", cursor: "pointer" }}>
                <SettingsIcon onClick={() => setAdd(true)} />
              </div>
              <div>
                <img
                  src="./user.png"
                  onClick={handleMenu}
                  alt="Not found"
                  style={{
                    height: "30px",
                    cursor: "pointer",
                  }}
                />
              </div>
            </div>

            {showdropdown && (
              <div
                className="logout-dropdown "
                style={{ position: "absolute" }}
              >
                <div>
                  Hi,{" "}
                  <span style={{ fontWeight: "500" }}>
                    {localStorage.getItem("username")}
                  </span>
                </div>
                <div
                  style={{ cursor: "pointer", marginTop: "16px" }}
                  onClick={handleClose}
                >
                  Logout
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {add && (
        <Settings
          modalOpen={add}
          handleClose={handleModalClose}
        />
      )}
    </>
  );
};
export default HomeHeader;
